import { FunctionComponent } from "react";

export type Logo = FunctionComponent;

export enum ProviderName {
  MetaMask = "MetaMask",
  TrustWallet = "TrustWallet",
  Unknown = "Unknown",
}
